var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellWithNoNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.804 10a8.2 8.2 0 015.442-7.722 2.804 2.804 0 015.508 0 8.2 8.2 0 015.443 7.723v3.445l1.454 2.799c1.038 1.997-.412 4.383-2.662 4.383h-3.318a3.803 3.803 0 01-7.34 0H3.01c-2.25 0-3.699-2.386-2.661-4.383l1.454-2.8v-3.444zm12 8.628H3.013a1 1 0 01-.888-1.461l1.567-3.016.113-.217V10a6.197 6.197 0 0112.393 0v3.934l.113.217 1.567 3.016a1 1 0 01-.888 1.46h-3.184zm-5.305 2a1.8 1.8 0 001.502.803 1.804 1.804 0 001.5-.803H8.5z",
    fill: "#666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWithNoNotifications);
export default __webpack_public_path__ + "static/media/BellWithNoNotifications.c569c9259121f465140bb81f9c6ebab7.svg";
export { ForwardRef as ReactComponent };